import React from 'react';
import { toast } from 'react-toastify';
import { callApi } from '../lib/api/callApi';

export function useUnifiedMutate() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [results, setResults] = React.useState();
  const [error, setError] = React.useState();

  const mutate = async ({ isMyEpik, endpoint, method, body }) => {
    try {
      setIsLoading(true);

      const apiResponse = await callApi({ isMyEpik, endpoint, method, body });

      setResults(apiResponse.data);

      toast.success('Success! Data updated.');
      return apiResponse.data;
    } catch (err) {
      let e = err.response.data;
      if ([404, 502, 400].includes(err.response.status)) {
        e = 'Data fetch error: Some functionality may be affected.';
      }
      setError(e);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, results, mutate, error };
}
